import { Link } from "react-router-dom";
import { heroImage, siteInfo, siteStats } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="网站介绍">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="爆料专区年度盘点专题主视觉，舞台灯光与人群剪影的抽象画面"
          title="爆料专区 · 年度盘点与旧瓜复盘"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />
      </div>

      <div className="relative mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-28 lg:py-32">
        <div className="max-w-3xl animate-fade-up">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs font-medium tracking-wide text-accent-300 backdrop-blur-sm">
            <i className="ri-fire-line" />
            2026 年度档案 · 持续更新中
          </p>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-[3.4rem]">
            <span className="mb-3 block font-body text-sm font-medium tracking-[0.3em] text-accent-400 md:text-base">
              {siteInfo.name} · 年度盘点
            </span>
            把散落的娱乐情报，整理成一条看得懂的时间线
          </h1>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            年度盘点、大事件回顾、旧瓜复盘、历史热点与新闻回顾，在这里被按主题与时间重新归档。一件早被刷过去的旧事，也能沿着完整的脉络重新读懂。老读者可以重温，新读者可以一次性补课。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-archive-2-line" />
              进入年度盘点
            </Link>
            <Link
              to="/archive?view=review"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-history-line" />
              翻一翻旧瓜复盘
            </Link>
          </div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-4 md:mt-20 md:grid-cols-4 md:gap-6">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/15 bg-background-50/10 p-4 backdrop-blur-sm md:p-5"
            >
              <dt className="text-xs tracking-wide text-background-300 md:text-sm">{stat.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}